import { call, put } from 'redux-saga/effects';
import * as actions from '../actions';
import * as api from '../../api';

export default function* searchPostsSaga(action) {
  try {
    yield put(actions.showLoading());
    let latestPosts = {};
    let allPosts = {};

    if (!action.payload.inAdminPage) {
      latestPosts = yield call(api.fetchPosts, { size: 5 });
    }

    if (action.payload.searchBy !== '') {
      allPosts = yield call(api.searchPostsApiService, {
        searchBy: action.payload.searchBy || undefined,
        pageNumber: action.payload.pageNumber ?? 1,
        pageSize: action.payload.pageSize ?? 10,
      });
    } else {
      allPosts = yield call(api.getPostsApiService, {
        pageNumber: action.payload.pageNumber ?? 1,
        pageSize: action.payload.pageSize ?? 10,
      });
    }

    yield put(actions.searchPosts.getSearchPostsSuccess({
      latest: (latestPosts.data && latestPosts.data.data) || [],
      allPosts: (allPosts.data && allPosts.data.data) || [],
      totalPosts: (allPosts.data && allPosts.data.total) ?? 0,
    }));
    yield put(actions.hideLoading());
  } catch (error) {
    console.log(error);
    yield put(actions.searchPosts.getSearchPostsFailure(error));
    yield put(actions.hideLoading());
  }
}